import React from 'react';
import { Link } from 'react-router-dom';

/**
 * Renders an accessible router <Link> when `to` is a real path, otherwise plain text.
 * This guarantees a missing relationship id (e.g. a ticket with no customer_id) produces
 * a non-link instead of a link to nowhere. Use with recordHref(), which returns null for
 * absent ids.
 */
export function RecordLink({ to, children, className, fallbackClassName, ...rest }) {
  if (!to) {
    return (
      <span className={fallbackClassName} {...rest}>
        {children}
      </span>
    );
  }
  return (
    <Link to={to} className={className} {...rest}>
      {children}
    </Link>
  );
}

export default RecordLink;
